import React, { useEffect, useState, useRef, useContext } from 'react';
import { AppContext } from './ContextVars';
import translations from './translations';

const PaymentComplete = () => {
  const { language } = useContext(AppContext);
  const t = (key) => translations.PaymentComplete[key]?.[language] || key;
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [paymentData, setPaymentData] = useState({});
  const transactionSent = useRef(false);

  useEffect(() => {
    // Parse query parameters from URL
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const description = params.get('description');
    const auth = params.get('auth');
    const order = params.get('order');
    const tilopayTransaction = params.get('tilopay-transaction');
    const returnData = params.get('returnData');


    const decodedReturnData = decodeURIComponent(atob(returnData));
    const returnParams = new URLSearchParams(decodedReturnData);
    
    // Extract all expected fields
    const email = returnParams?.get('email');
    const firstName = returnParams?.get('firstName');
    const lastName = returnParams?.get('lastName');
    const phone = returnParams?.get('phone');
    const country = returnParams?.get('country');
    const city = returnParams?.get('city');
    const amount = returnParams?.get('amount');
    const currency = returnParams?.get('currency');
    const returnDescription = returnParams?.get('description');
    const orderNumber = returnParams?.get('orderNumber');
    const productsPre = returnParams?.get('products');
    const products = JSON.parse(productsPre);

    console.log('returnData:', decodedReturnData);

    // Decode returnData if needed
    // const decodedReturnData = returnData ? decodeURIComponent(atob(returnData)) : null; // #removed 23/5/25 TG

    
    // Set payment status and data
    setPaymentStatus(code === '1' ? 'success' : 'failure');
    setPaymentData({
        code,
        description,
        auth,
        order,
        tilopayTransaction,
        email,
        firstName,
        lastName,
        phone,
        country,
        city,
        amount,
        currency,
        returnDescription,
        orderNumber,
        products,
        paymentMethod: 'tilopay',
        status: (code === '1' ? 'success' : 'failure'),
    });
    /*setPaymentData({ // #mod 23/5/25 TG
      description,
      auth,
      order,
      tilopayTransaction,
      returnData: decodedReturnData,
    });*/

    
}, []);


useEffect(() => { // #added 29/5/25 TG
  if (paymentData && paymentData.orderNumber && !transactionSent.current) {
      transactionSent.current = true;
      // Send the transaction data to the server
      storeTransaction();
    }
}, [paymentData]);

const storeTransaction = async () => {
  try {
    console.log("sending..." + JSON.stringify(paymentData));
    const response = await fetch('https://eleven.fit/php/store-transaction.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(paymentData)
    });

    const text = await response.text(); // 🔍 Read raw text
    let data;

    try {
      data = JSON.parse(text); // Try parsing it
    } catch (parseErr) {
      console.error("❌ Failed to parse JSON from server:");
      console.error("Raw response:", text);
      return;
    }

    if (!response.ok || !data.success) {
      console.error('Store failed:', data.message || 'Request failed');
      return;
    }

    console.log('✅ Transaction stored successfully:', data);
  } catch (error) {
    console.error("❌ Network or server error while storing transaction:", error);
  }
};


const storeTransaction2 = async () => { // #replaced 1/8/25 TG
    try {
      console.log("sending..." + JSON.stringify(paymentData));
      const response = await fetch('https://eleven.fit/php/store-transaction.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(paymentData)
      });

      const data = await response.json();

      if (!response.ok) {
        console.error('Store failed:', data.message || 'Request failed');
        return;
      }

      console.log('Transaction stored successfully:' + JSON.stringify(data));
      // console.log('Transaction stored successfully:', data);
    } catch (error) {
      console.error("Network or server error while storing transaction:");
      
      /*if (error instanceof SyntaxError && error.message.includes('Unexpected token')) {
        // Likely HTML returned instead of JSON
        const responseText = await fetch("https://fitfluencers.store/api/insert-transaction.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(paymentData)
        }).then(r => r.text());

        console.log("Raw response:", responseText);
      } else {
        console.error(error);
      }*/
    }
  };


    //---------------------------------
    // JSX
    //---------------------------------

  return (
    <div>
    {/* <div style={{ padding: '2rem', textAlign: 'center' }}> */}
      
         <section id={paymentStatus === 'success' ? "payment-successful" : "payment-failed"} className="section overlay tint-black-40 height-40vh">
            <div className="section__content">
            <h2 className="general-title">
            {paymentStatus == null 
              ? t('loading')
              : paymentStatus === 'success' 
                ? t('success')
                : t('failure')}
          </h2>
            <h2 className="font-size-20 color-gray-3 max-width-70">
                {paymentStatus === 'success' ? 
                    t('successSub')
                    :
                    t('failureSub')}
            </h2>
            </div>
        </section>

        <section className="section-2 bg-image-floor overlay tint-black-50">

            <div className="section__content">

                <div className="">
                
                    {/* #Payment #Status TG */}
                    {paymentStatus === 'success' ? (
                            <div>
                                <h1 className="general-h3 color-1 margin-bottom-40">{t('thanks')}</h1>
                                <div className="margin-0-auto general-description">
                                    <p><strong>{t('order')}</strong> {paymentData.order}</p>
                                    <p className="margin-top-20">{t('emailSent')}</p>
                                    <p className="margin-top-20">{t('activationInfo')}</p>
                                    <p className="margin-top-20">{t('contactSupport')}</p>
                                    {/* <p className="margin-top-20">Follow the instructions below to get your workouts in our app. These instructions will be included in the email as well, along with the instructions to create a user, if you haven't yet.</p> */}
                                    {/* <p><strong>Authorization:</strong> {paymentData.auth}</p> */}
                                    {/* <p><strong>Tilopay Tx:</strong> {paymentData.tilopayTransaction}</p> */}
                                    {/*paymentData && (
                                        <p><strong>Return Data:</strong> {JSON.stringify(paymentData)}</p>
                                    )*/}
                                </div>
                            </div>
                        ) : paymentStatus === 'failure' ? (
                            <div>
                                <h1>{t('paymentFailed')}</h1>
                                <p>{paymentData.description || (language === 'es' ? 'La transacción no fue aprobada.' : 'The transaction was not approved.')}</p>
                            </div>
                        ) : (
                            <p>{t('processing')}</p>
                        )}


                
                </div>

            
            </div>
        </section>

      
    </div>
  );
};

export default PaymentComplete;